/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";

import * as url from "helper/UrlHelper";
import { assetImages } from "constants";

const RecivedInviteTab = ({
  inviteList,
  rejectInviteHandler,
  acceptHandler,
}) => {
  return (
    <div className="notification_inner">
      <div className="post_item">
        {inviteList.map((inviteData, index) => {
          return (
            <div
              className="white_shadow_bx people_bx bg_white rounded-10 p-3"
              key={index}
            >
              <div className="d-flex align-items-center justify-content-between">
                <div className="left_people d-flex gap-3">
                  <div className="people_profile rounded-circle overflow-hidden">
                    <img
                      src={
                        inviteData.senderimage == ""
                          ? assetImages.defaultUser
                          : url.SERVER_URL + inviteData.senderimage
                      }
                      alt=""
                    />
                  </div>
                  <div className="people_profile_info">
                    <h3>{inviteData.sendername}</h3>
                    <h5>{inviteData.senderposition}</h5>
                    <h5>{inviteData.sendercompany}</h5>
                    {/* <div className="event_tags">
                      <ul className="list_style_none mb-0">
                        <li>
                          <i className="material-icons-outlined ornge_icon">
                            star
                          </i>
                          <span className="rating">
                            4.5 <em>(32)</em>
                          </span>
                        </li>
                      </ul>
                    </div> */}
                  </div>
                </div>
                <div className="right_people_btn">
                  <Link
                    to="#"
                    className="btn gray_btn"
                    onClick={() => {
                      rejectInviteHandler(inviteData.owner._id);
                    }}
                  >
                    Reject
                  </Link>
                  <Link
                    to="#"
                    className="btn outline"
                    onClick={() => {
                      acceptHandler(inviteData._id);
                    }}
                  >
                    Accept
                  </Link>
                </div>
              </div>
            </div>
          );
        })}

        {inviteList.length == 0 ? (
          <p className="text-primary mt-4 fs-sm fw-medium text-uppercase">
            No pending invites
          </p>
        ) : null}

        {/* <div className="white_shadow_bx people_bx bg_white rounded-10 p-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="left_people d-flex gap-3">
              <div className="people_profile rounded-circle overflow-hidden">
                <img src="images/people1.png" alt="" />
              </div>
              <div className="people_profile_info">
                <h3>Harry Nonalarm</h3>
                <h5>Sales Manager at Lobees Ecosystem</h5>
                <div className="event_tags">
                  <ul className="list_style_none mb-0">
                    <li>
                      <i className="material-icons-outlined ornge_icon">star</i>
                      <span className="rating">
                        4.5 <em>(32)</em>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="right_people_btn">
              <Link to="#" className="btn gray_btn">
                Reject
              </Link>
              <Link to="#" className="btn outline">
                Accept
              </Link>
            </div>
          </div>
        </div>
        <div className="white_shadow_bx people_bx bg_white rounded-10 p-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="left_people d-flex gap-3">
              <div className="people_profile rounded-circle overflow-hidden">
                <img src="images/people2.png" alt="" />
              </div>
              <div className="people_profile_info">
                <h3>Clare MacLearn</h3>
                <h5>Sales Manager at Lobees Ecosystem</h5>
                <div className="event_tags">
                  <ul className="list_style_none mb-0">
                    <li>
                      <i className="material-icons-outlined ornge_icon">star</i>
                      <span className="rating">
                        4.5 <em>(32)</em>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="right_people_btn">
              <Link to="#" className="btn gray_btn">
                Reject
              </Link>
              <Link to="#" className="btn outline">
                Accept
              </Link>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default RecivedInviteTab;
